import { render, staticRenderFns } from "./helpMenu.vue?vue&type=template&id=19ed4e5b&scoped=true&"
import script from "./helpMenu.vue?vue&type=script&lang=js&"
export * from "./helpMenu.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./helpMenu.vue?vue&type=style&index=0&id=19ed4e5b&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "19ed4e5b",
  null
  ,true
)

export default component.exports